// Fallback art for a badge the parts library cannot draw: the old full SVG from
// GCS, served by the backend at GET /api/badges/badge-image/:code (auth required).
// One request per code per page load; logged-out viewers skip straight to the
// initials tile, so a public page never triggers a token refresh.
import { apiClient } from "../../../api/client";
import { getAuthToken } from "../../../utils/authTokens";

const TIMEOUT_MS = 8000;
const cache = new Map<string, Promise<string | null>>();

export function loadLegacyBadgeImage(code: string): Promise<string | null> {
  if (!code || !getAuthToken()) return Promise.resolve(null);
  let hit = cache.get(code);
  if (!hit) {
    hit = apiClient
      .get(`/api/badges/badge-image/${encodeURIComponent(code)}`, { responseType: "blob", timeout: TIMEOUT_MS })
      .then((res) => {
        const blob = res.data as Blob;
        if (!blob || !blob.size) return null;
        return URL.createObjectURL(blob);
      })
      .catch(() => null);
    cache.set(code, hit);
  }
  return hit;
}
